import dayjs from 'dayjs'

import { callApiNew } from 'api/axios'
import {
  formatTogetherCommunity,
  formatTogetherPost,
  formatTogetherTopic,
} from 'api/dataTransform'
import { PATHS } from 'api/paths'
import {
  TogetherCommunity,
  TogetherPost,
  TogetherPostApi,
  TogetherTopic,
  TogetherTopicApi,
} from 'interfaces/types'
import uniqBy from 'lodash/uniqBy'

export const getCommunityInfo = async (
  query: Record<string, any>,
  fetchFunction: typeof callApiNew,
) => {
  const communityRes = await fetchFunction(
    PATHS.TOGETHER.GET_TOGETHER_COMMUNITY_DETAIL,
    { params: query },
    'together',
  )

  return communityRes?.data
    ? formatTogetherCommunity(communityRes?.data)
    : ({} as TogetherCommunity)
}

export const getTopicInfo = async (
  query: Record<string, any>,
  fetchFunction: typeof callApiNew,
) => {
  const topicsRequest = await fetchFunction(
    PATHS.TOGETHER.GET_TOGETHER_TOPICS,
    { params: query },
    'together',
  )

  return (
    (topicsRequest?.data?.topics?.map((topic: TogetherTopicApi) =>
      formatTogetherTopic(topic),
    ) as TogetherTopic[]) || []
  ).filter((e) => e?.isActive)
}

export const getPostList = async (
  query: Record<string, any>,
  fetchFunction: typeof callApiNew,
) => {
  const { articleId, ...restQuery } = query
  try {
    const [guestPostsRequestByArticle, guestPostsRequest] = await Promise.all([
      fetchFunction(
        PATHS.TOGETHER.GET_TOGETHER_POST_LIST,
        {
          params: {
            ...restQuery,
            articleId: articleId || '',
            sortBy: 'popularity',
            postBy: 'member',
          },
        },
        'together',
      ),
      fetchFunction(
        PATHS.TOGETHER.GET_TOGETHER_POST_LIST,
        {
          params: {
            ...restQuery,
            reportStartDate: dayjs().subtract(2, 'month').format('YYYY-MM-DD'),
            reportEndDate: dayjs().format('YYYY-MM-DD'),
            sortBy: 'popularity',
            postBy: 'member',
          },
        },
        'together',
      ),
    ])
    const currentPostsList: Array<TogetherPostApi> = [
      ...guestPostsRequest?.data?.posts,
      ...guestPostsRequestByArticle.data?.posts,
    ].sort((a: TogetherPostApi, b: TogetherPostApi) => {
      return dayjs(a.created_at).isBefore(dayjs(b.created_at)) ? 1 : -1
    })

    return (
      (uniqBy(currentPostsList, 'id').map((post: TogetherPostApi) =>
        formatTogetherPost(post),
      ) as TogetherPost[]) || []
    )
  } catch (err) {
    return []
  }
}
